import { createImagesWithPixelDensity } from './createImagesWithPixelDensity'

export interface ICatalogImage {
  type: string
  src: string
  srcSet: string
}

export interface ICatalogImages {
  webp?: ICatalogImage
  webpDesktop?: ICatalogImage
  webpHighResolution?: ICatalogImage
  jpg: ICatalogImage
}

export const createImages = (image?: string): ICatalogImages | null => {
  if (!image) {
    return null
  }

  const dpiImages = createImagesWithPixelDensity(image, 'webp')
  const fallbackImage = image.replace(/\.jpg$/i, '.webp')

  const regexLowDpiImage = /\s1x/i

  const mediaType = 'image/webp'

  const imagesExceptLowDpi = dpiImages.filter((image) => !regexLowDpiImage.test(image))

  return {
    webpDesktop: {
      srcSet: imagesExceptLowDpi.join(', '),
      type: mediaType,
      src: fallbackImage,
    },
    webp: {
      srcSet: dpiImages.join(', '),
      type: mediaType,
      src: fallbackImage,
    },
    webpHighResolution: {
      srcSet: fallbackImage,
      type: mediaType,
      src: fallbackImage,
    },
    jpg: { srcSet: image, type: 'image/jpeg', src: image },
  }
}
